import { IScope } from "../../../../global";
import { SECRET_VALUE_MARK } from "./common";
import Values from "./values";

export default function SecretValues({ scope }: { scope: IScope }) {
    return <Values scope={scope} mark={SECRET_VALUE_MARK} type='secret' />
}
